"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobStatus = exports.JobTypes = void 0;
var JobTypes;
(function (JobTypes) {
    JobTypes["TRANSLATION__GENERATE_TRANSLATION"] = "translation:generate_translation";
    JobTypes["TRANSLATION__INSTANT_MIGRATION"] = "translation:instant_migration";
    JobTypes["IRB__CREATE_PACKAGE_STEP_2_GENERATE_TEMPLATE_SCREENSHOTS"] = "irb:create_package_step_2_generate_template_screenshots";
    JobTypes["IRB__CREATE_PACKAGE_STEP_3_TRACK_REAL_SCREENSHOT_API"] = "irb:create_package_step_3_track_real_screenshot_api";
    JobTypes["IRB__CREATE_PACKAGE_STEP_4_COMPOSE_FINAL_PACKAGE"] = "irb:create_package_step_4_compose_final_package";
})(JobTypes || (exports.JobTypes = JobTypes = {}));
var JobStatus;
(function (JobStatus) {
    JobStatus["NEW"] = "new";
    JobStatus["IN_PROGRESS"] = "in_progress";
    JobStatus["ERROR"] = "error";
    JobStatus["DONE"] = "done";
})(JobStatus || (exports.JobStatus = JobStatus = {}));
//# sourceMappingURL=types.js.map